import { getCookieValue } from '../../../assets/js/utils/getCookieValue';
import { getXhrDomain } from '../../../assets/js/utils/getXhrDomain';

async function fetchSelectOrganization(selectOrganizationApiUrl, organization) {
    const antiForgeryResponse = await fetch(getXhrDomain() + '/antiforgery/token', {
        method: 'GET',
    });

    if (!antiForgeryResponse.ok) {
        const message = `An error has occurred: ${antiForgeryResponse.status}`;
        throw new Error(message);
    }
    const response = await fetch(selectOrganizationApiUrl, {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
        },
        body: JSON.stringify({
            organizationId: organization.id,
            organizationGroupsIds: organization.organizationGroups,
        }),
    });

    if (!response.ok) {
        const message = `An error has occurred: ${response.status}`;
        throw new Error(message);
    }

    return response;
}

export { fetchSelectOrganization };
